import request from '../../utils/request';

/** 查本地缓存的扫描与逐条判定：ml-services 现扫盘现问训练机，判定理由原样给出 */
export function fetchCacheInventory() {
  return request.get('/blissrose/datasets/cache');
}

/** 按勾选回收本地缓存：动手前 ml-services 重判一次，删不掉的逐条带理由回来 */
export function deleteCache(body) {
  return request.post('/blissrose/datasets/cache/delete', body);
}
